module.exports = __webpack_public_path__ + "img/CSIRO-logo--black-reversed.svg";